module.exports = __webpack_public_path__ + "img/eyyb-t4.c5209d26.jpg";